import {Component} from '@angular/core';
import {SpinnerComponent} from "../../../utils/spinner/spinner.component";
import {AConcreteResource} from "../../../AConcreteResource";
import {CustomerModel} from "../../../../models/resources/customer.model";
import {Router, RouterOutlet} from "@angular/router";
import {CustomerService} from "../../../../services/resources/customer.service";
import {BtnGroupNavComponent} from "../../../utils/btn-group-nav/btn-group-nav.component";
import {SubPageModel} from "../../../../models/sub-page.model";

@Component({
  selector: 'app-customer',
  imports: [
    SpinnerComponent,
    RouterOutlet,
    BtnGroupNavComponent
  ],
  templateUrl: './customer.component.html',
  styleUrl: './customer.component.scss'
})
export class CustomerComponent extends AConcreteResource<CustomerModel> {
  pages: SubPageModel[] = [
    {
      value: 'DATA',
      link: '.',
      isBasePage: true,
      icon: 'fas fa-info-circle'
    },
    {
      value: 'CUSTOMERS.CONTACTS',
      link: 'contacts',
      icon: 'fas fa-address-book'
    },
    {
      value: 'CUSTOMERS.SALES_PURCHASE',
      link: 'sales-purchase',
      icon: 'fas fa-handshake'
    },
    {
      value: 'CUSTOMERS.ACCOUNTING',
      link: 'accounting',
      icon: 'fas fa-file-invoice-dollar'
    },
    {
      value: 'CUSTOMERS.PARTNER_ASSIGNMENT',
      link: 'partner-assignment',
      icon: 'fas fa-map-marker-alt'
    }
  ];
  activePage: SubPageModel = this.pages[0];

  constructor(router: Router, customerService: CustomerService) {
    super(router, customerService);
  }
}
